export const breakpoint = 900;
export const containerID = 'c-5m';
export const assets_path = '/assets/';
